/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveaways_RepeatedInputs */

const id_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diulang:`)
};

const ms_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berulang:`)
};

const da_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gentaget:`)
};

const de_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholt:`)
};

const en_us2_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeated:`)
};

const es_es2_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetido:`)
};

const es_mx2_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetido:`)
};

const fil_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inulit:`)
};

const fr_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répété :`)
};

const it_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetuto:`)
};

const hu_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismételt:`)
};

const nl_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herhaald:`)
};

const no_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gjentatt:`)
};

const pl_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powtórzone:`)
};

const pt_br2_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeated:`)
};

const pt_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetido:`)
};

const ro_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetat:`)
};

const fi_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toistettu:`)
};

const sv_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upprepad:`)
};

const vi_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lặp lại:`)
};

const tr_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrarlanan:`)
};

const cs_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opakováno:`)
};

const bg_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повтаря се:`)
};

const ru_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторяется:`)
};

const uk_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторюється:`)
};

const ar_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكرر:`)
};

const hi_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोहराया गया:`)
};

const th_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำซ้ำ:`)
};

const ja_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繰り返し：`)
};

const zh_cn2_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeated:`)
};

const zh_hant1_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeated:`)
};

const ko_components_giveaways_repeated = /** @type {(inputs: Components_Giveaways_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeated:`)
};

/**
* | output |
* | --- |
* | "Repeated:" |
*
* @param {Components_Giveaways_RepeatedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveaways_repeated = /** @type {((inputs?: Components_Giveaways_RepeatedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveaways_RepeatedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveaways_repeated(inputs)
	if (locale === "ms") return ms_components_giveaways_repeated(inputs)
	if (locale === "da") return da_components_giveaways_repeated(inputs)
	if (locale === "de") return de_components_giveaways_repeated(inputs)
	if (locale === "en-US") return en_us2_components_giveaways_repeated(inputs)
	if (locale === "es-ES") return es_es2_components_giveaways_repeated(inputs)
	if (locale === "es-MX") return es_mx2_components_giveaways_repeated(inputs)
	if (locale === "fil") return fil_components_giveaways_repeated(inputs)
	if (locale === "fr") return fr_components_giveaways_repeated(inputs)
	if (locale === "it") return it_components_giveaways_repeated(inputs)
	if (locale === "hu") return hu_components_giveaways_repeated(inputs)
	if (locale === "nl") return nl_components_giveaways_repeated(inputs)
	if (locale === "no") return no_components_giveaways_repeated(inputs)
	if (locale === "pl") return pl_components_giveaways_repeated(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveaways_repeated(inputs)
	if (locale === "pt") return pt_components_giveaways_repeated(inputs)
	if (locale === "ro") return ro_components_giveaways_repeated(inputs)
	if (locale === "fi") return fi_components_giveaways_repeated(inputs)
	if (locale === "sv") return sv_components_giveaways_repeated(inputs)
	if (locale === "vi") return vi_components_giveaways_repeated(inputs)
	if (locale === "tr") return tr_components_giveaways_repeated(inputs)
	if (locale === "cs") return cs_components_giveaways_repeated(inputs)
	if (locale === "bg") return bg_components_giveaways_repeated(inputs)
	if (locale === "ru") return ru_components_giveaways_repeated(inputs)
	if (locale === "uk") return uk_components_giveaways_repeated(inputs)
	if (locale === "ar") return ar_components_giveaways_repeated(inputs)
	if (locale === "hi") return hi_components_giveaways_repeated(inputs)
	if (locale === "th") return th_components_giveaways_repeated(inputs)
	if (locale === "ja") return ja_components_giveaways_repeated(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveaways_repeated(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveaways_repeated(inputs)
	return ko_components_giveaways_repeated(inputs)
});
export { components_giveaways_repeated as "components.giveaways.repeated" }